import { render, staticRenderFns } from "./comExam.vue?vue&type=template&id=253f3026&scoped=true"
import script from "./comExam.vue?vue&type=script&lang=js"
export * from "./comExam.vue?vue&type=script&lang=js"
import style0 from "./comExam.vue?vue&type=style&index=0&id=253f3026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f3026",
  null
  
)

export default component.exports